
define('template!productAlternativesTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="row">\n    <div class="col-xs-12">\n        <div class="col-xs-12 prices-header-table">\n            <div class="col-xs-1 h-16"></div>\n            <div class="col-xs-3">' +
((__t = ( _.i18n("common.code") )) == null ? '' : __t) +
'</div>\n            <div class="col-xs-3">' +
((__t = ( _.i18n("common.name") )) == null ? '' : __t) +
'</div>\n            <div class="col-xs-3">' +
((__t = ( _.i18n("common.supplier") )) == null ? '' : __t) +
'</div>\n            <div class="col-xs-1 h-16"></div>\n        </div>\n    </div>\n</div>\n<div class="row">\n    <div class="col-xs-12 alternatives-items">\n\n    </div>\n</div>\n<div class="row">\n    <div class="col-xs-12">\n        <div class="col-xs-12">\n            <div class="btn btn-add-alternative p-l-0 p-r-0 p-t-0 p-b-0">\n                <i class="mdi-content-add"></i>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
};});

